import React from "react";
import teethLogo from "../../assets/Images/teeth-logo.png"
import redSeaBeach from "../../assets/Images/red-sea-beach.jpg"
import redSeaDiving from "../../assets/Images/red-sea-diving.jpg"
import redSeaKiteSuffing from "../../assets/Images/red-sea-kite-surfing.jpg"
import VideoPlayer from "../YoutubePlayer/YoutubePlayer";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import allPaths from "../../Config/paths"

const HomeEgypt = (props) => {
    const history = useHistory()
    const { selectedLanguage } = props
    return (
        <div className="home-egypt-main">
            <div className="home-egypt-container">
                <div className="home-egypt-left-side-div">
                    <div className="teeth-logo-div">
                        <img className="teeth-logo" src={teethLogo} alt="" />
                        <div className="service-heading-div egypt-heading-div-1">
                            <h2 className="service-heading">
                                {selectedLanguage?.why_egypt_heading}
                            </h2>
                        </div>
                    </div>
                    <div>
                        <p className="egypt-left-side-text">{selectedLanguage?.why_egypt_paragraph_we_are_located}</p>
                    </div>
                    <div className="egypt-left-side-img-div" data-aos="fade-right"
                        data-aos-easing="ease-out-cubic"
                        data-aos-delay="100"
                        data-aos-offset="0"
                        data-aos-duration="1500">
                        <div>
                            <img src={redSeaBeach} alt="" />
                        </div>
                        <div>
                            <img src={redSeaDiving} alt="" />
                        </div>
                        <div>
                            <img src={redSeaKiteSuffing} alt="" />
                        </div>
                    </div>
                    <div>
                        <button data-aos="fade-up"
                            data-aos-easing="ease-out-cubic"
                            data-aos-delay="100"
                            data-aos-offset="0"
                            data-aos-duration="1000" className="card-section-2-btn egypt-btn" onClick={() => history?.push(allPaths?.EGYPT)}>{selectedLanguage?.read_more_button}</button>
                    </div>
                </div>
                <div className="home-egypt-right-side-div">
                    <div className="teeth-logo-div">
                        <img className="teeth-logo" src={teethLogo} alt="" />
                        <div className="service-heading-div egypt-heading-div-2">
                            <h2 className="service-heading">
                                {selectedLanguage?.latest_updated_heading}
                            </h2>
                        </div>
                    </div>
                    <div className="home-egypt-right-side-text">
                        <p>{selectedLanguage?.latest_update_paragraph} <i>19 {selectedLanguage?.txt_november} 2012</i></p>
                    </div>
                    <div data-aos="fade-right"
                        data-aos-easing="ease-out-cubic"
                        data-aos-delay="100"
                        data-aos-offset="0"
                        data-aos-duration="1500">
                        <VideoPlayer />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeEgypt